/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
/* eslint-disable arrow-body-style */
/* eslint-disable max-len */
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FileSizeFormatPipe, XsI18nPipe } from '@nx-fe/pipes';
import {
  emailRecipientType,
  ErrorHandlerService,
  FeatureToggleService,
  GlobalEventBusService,
  hd,
  IEmailRecipient,
  IReporterModel,
  IUserEmailRecipient,
  IUserInfoModel,
  LoggerService,
  ObjectService,
  TicketContextService,
  TicketService,
  UserContextService,
  UserInfoService,
} from '@nx-fe/services';
import { AttachmentService, IAttachmentModel } from '../../.././services/attachment.service';
import Quill, * as quill from 'quill';

import { ActivityContextService } from '../activity/activity-context';
import {
  Activity,
  EmailAttachmentFile,
  ActivityTypeEnum,
  AttachmentActivity,
  EmailActivity,
  EmailAttachment,
  EmailContainer,
} from 'xsmodules/ticket/ticket.model';
import { switchMap, take } from 'rxjs/operators';
import { EmailActivityService } from 'app/modules/ticket/services/email.service';
import { GlobalEvents } from 'app/core/global-event-constants';
import { of, zip } from 'rxjs';
import { TicketPageService } from 'app/modules/ticket/ticket-page.service';

@Component({
  selector: 'xs-outbound-email-activity',
  templateUrl: './outbound-email-activity.component.html',
  styleUrls: ['./outbound-email-activity.component.scss'],
})
export class OutboundEmailActivityComponent implements OnInit, OnDestroy {
  // Image compression settings for pasted inline images
  private static readonly imageCompressionSettings = {
    type: 'image/jpeg',
    quality: 0.8,
  };

  /** The activity for this email, set during controller initialization */
  @Input()
  public activity: EmailActivity;
  /** Used to determine if the user has edit permissions */
  @Input()
  public canEdit: boolean;
  /** The ActivityController exposes methods for saving, deleting, and updating activities */
  @Input()
  public activityCtrl: ActivityContextService;
  /** Error encountered during sending the email */
  @Input()
  public error: string;
  /** The working body text */
  public body = '';
  /** The working body Delta object */
  public bodyDelta: quill.DeltaStatic;
  /** The email "to" recipients */
  public recipientsTo: string;
  /** The email "cc" recipients */
  public recipientsCC: string;
  /** List of user info models for the email recipients */
  public recipientsUserInfos: IUserInfoModel[] = [];
  /** List of user info models of the email CC recipients */
  public recipientsCCUserInfos: IUserInfoModel[] = [];
  /** When this value is toggled, the focus is set on the recipients field */
  public toggleRecipientsFocus = false;
  /** When this value is toggled, the focus is set on the body field */
  public toggleBodyFocus = false;
  /** Indicate if the email body is focused */
  public isBodyFocused = false;
  /** List of recipient emails to be displayed on the activity */
  public emailList: string;
  /** Boolean switch that collapses the email body text area whenever it is toggled */
  public toggleCollapseEmailBody: boolean;
  /** List of activity attachments */
  public activityAttachments: AttachmentActivity[] = [];
  /** List of activity attachments */
  public activityImageAttachments: AttachmentActivity[] = [];
  /** Attachment menu popup toggle */
  public toggleAttachmentPopup = false;
  /** Inline image menu popup toggle */
  public toggleInlinePopup = false;
  /** Show Email Attachments (Replacing the deleted OutboundEmailAttachments toggle) */
  public toggleEmailAttachment = true;
  /** Indicates whether the activity is currently being saved */
  private _isSaving = false;
  /** Indicates whether a duplicate attachment has been added */
  private duplicateExists = false;

  /** Activity resource for creating attachment activities */
  private ticketActivityResource: hd.IResourceClass<hd.IActivityModel>;
  /** Attachments on an already sent email */
  private emailAttachments: AttachmentActivity[] = [];
  /** List of email attachment files */
  private emailAttachmentFiles: EmailAttachmentFile[] = [];
  /** Dictionary of email attachment files with their number of occurences */
  private emailAttachmentsDictionary: { [key: string]: number } = {};
  /** Maximum upload size for email attachments */
  private _maxAttachmentSize = 0;
  /** Maximum upload file size of the Attachment APIs */
  private readonly _maxApiFileSize = 2000000000 / 1024 / 1024;
  /** Indicates whether an attachment is being uploaded */
  private isUploading = false;
  /** The progress of uploading the email attachment to the server */
  private progress = 0;
  /** The promise of the upload-attachment server interaction  */
  private uploadPromise: hd.IUploadPromise;
  /** Indicates whether the cancel upload attachment button was pressed  */
  private cancelUploadPressed = false;
  /** User Info Resource for querying users */
  private userInfoResource: hd.IResourceClass<IUserInfoModel>;
  /** Quill rich text editor instance */
  private quillEditor: Quill; // quill.Quill;
  /** Dictionary of activity ids to download URLs for inline image attachments */
  private inlineImageAttachmentUrls: { activityId: number; url: string }[] = [];
  /** list of valid image file extension */
  private imageExtensionList: string[] = ['.png', '.jpeg', '.jpg', '.jfif', '.gif', '.bmp'];
  /** Indicate whether the content email body Delta has been changed */
  private isBodyDeltaDirty = false;
  /** stateChangeStart listener */
  private stateChangeStartListener: Function;
  /** onBeforeUnload listener */
  private onBeforeUnloadListener: Function;
  /** RegExp for validating email adresses */
  private pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

  private email: EmailContainer;
  public quillModules;

  quill: any;

  get isDirty(): boolean {
    return !(this.isInactivityState() || this.body == this.email?.body);
  }

  constructor(
    private $log: LoggerService,
    private $filter: XsI18nPipe,
    private ticketService: TicketService,
    private ticketContextService: TicketContextService,
    private attachmentService: AttachmentService,
    private errorHandlerService: ErrorHandlerService,
    private userContextService: UserContextService,
    private featureToggleService: FeatureToggleService,
    private userInfoService: UserInfoService,
    private objectService: ObjectService,
    private globalEventBusService: GlobalEventBusService,
    private emailService: EmailActivityService,
    private ticketPageService: TicketPageService,
    private fileSizeFormatter: FileSizeFormatPipe
  ) {
    this.quillModules = this.prepareQuillModules();
  }

  /**
   * Called to pass required information during controller initialization.
   */
  public async ngOnInit() {
    if (this.isNew()) {
    }

    this.email = {
      activityId: this.activity.activityId,
      ticketId: parseInt(this.ticketContextService.ticket.ticketId),
      recipients: this.ticketContextService.outboundEmailRecipientList as any,
      attachmentActivityIds: [],
      body: {},
      subject: '',
    };

    // Pre-process activity body delta
    if (this.activity.details.body) {
      this.email = JSON.parse(this.activity.details.body);
      this.bodyDelta = await this.preProcessDelta();
      this.body = this.bodyDelta.ops[0].insert;
    }

    if (this.activity.details?.status === 'draft' && this.activity.activityId) {
      this.setError(this.$filter.transform('email_Save_Error'));
    }

    //Get list of email attachments
    if (this.activity.activityId) {
      this.ticketService.getEmailAttachmentFiles(this.activity.activityId).subscribe(
        data => {
          data.forEach(attachmentFile => {
            this.emailAttachmentFiles.push(attachmentFile);
            const attachmentAct = {
              activityId: this.activity.activityId,
              activityTypeId: this.activity.activityTypeId,
              details: {
                fileName: attachmentFile.fileName,
                fileSize: attachmentFile.fileSize,
                fileId: attachmentFile.fileId,
                displayName: attachmentFile.displayName,
              },
            } as AttachmentActivity;
            this.emailAttachments.push(attachmentAct);
          });
        },
        error => (this.error = error)
      );
    }

    this.updateActivityState();

    if (this.ticketContextService.ticket === undefined || this.ticketContextService.ticket === null) {
      return;
    }

    this.ticketContextService.updateManualReporterInfo.subscribe(updatedReporter => {
      this.updateReporter(updatedReporter);
    });

    let recipientCCIds = this.email.recipients
      .filter(x => x.recipientType === 'cc')
      .map(x => (x.hasOwnProperty('user') ? x['user'].userId : x.userId));

    if (this.email.recipients && this.email.recipients.length > 0) {
      let recipientIds = this.email.recipients
        .filter(x => x.recipientType === 'to')
        .map(x => (x.hasOwnProperty('user') ? x['user'].userId : x.userId));
      this.userContextService
        .getUserInfoList(recipientIds)
        .pipe(take(1))
        .subscribe(result => {
          this.recipientsUserInfos = result;
        });
    }

    if (recipientCCIds && recipientCCIds.length > 0) {
      this.userContextService
        .getUserInfoList(recipientCCIds)
        .pipe(take(1))
        .subscribe(result => {
          this.recipientsCCUserInfos = result;
        });
    }
  }

  public ngOnDestroy = () => {
    if (this.stateChangeStartListener) {
      this.stateChangeStartListener();
    }

    if (this.onBeforeUnloadListener) {
      this.onBeforeUnloadListener();
    }

    if (this.ticketContextService.updateManualReporterInfo) {
      this.ticketContextService.updateManualReporterInfo.unsubscribe();
    }
  };

  /**
   * Gets the array that stores email addresses for outbound email drafts.
   * This is a stand-in for the now-removed public 'recipients' property on IEmailActivity,
   * to limit the amount of refactoring necessary.
   */
  public get recipientsList(): IEmailRecipient[] | IUserEmailRecipient[] {
    // Back with ticketContextService property so it can be read/written from other controllers.
    return this.ticketContextService.outboundEmailRecipientList;
  }

  /** Sets the array that stores email addresses for outbound email drafts */
  public set recipientsList(list: IEmailRecipient[] | IUserEmailRecipient[]) {
    this.ticketContextService.outboundEmailRecipientList = list;
  }

  public getAttachments = (): AttachmentActivity[] => {
    let attachments: AttachmentActivity[] = [];
    const currentActivities = this.ticketContextService.activities;
    if (currentActivities) {
      attachments = attachments.concat(this.findAttachmentsInActivities(currentActivities));
      for (const attachment of this.emailAttachments) {
        for (let i = 0; i < attachments.length; i++) {
          const dropdownAttachment = attachments[i];
          if (
            dropdownAttachment.details.fileId === (attachment.details ? attachment.details.fileId : attachment.fileId)
          ) {
            attachments.splice(i, 1);
            break;
          }
        }
      }
      this.activityAttachments = attachments;
    }
    return this.activityAttachments;
  };

  public imageAttachments: AttachmentActivity[] = [];

  public getImageAttachments = (): AttachmentActivity[] => {
    let attachments: AttachmentActivity[] = [];
    const imageAttachments: AttachmentActivity[] = [];
    const currentActivities = this.ticketContextService.activities;
    if (currentActivities) {
      attachments = attachments.concat(this.findAttachmentsInActivities(currentActivities));
      for (const attachment of attachments) {
        if (attachment.details.fileName) {
          const extension = attachment.details.fileName
            .substring(attachment.details.fileName.lastIndexOf('.'))
            .toLowerCase();
          if (this.imageExtensionList.indexOf(extension) > -1) {
            imageAttachments.push(attachment);
          }
        }
      }
    }
    // prevent infinite digest loop called on the child component such as AttachmentMenu Component
    if (!this.objectService.equals(this.activityImageAttachments, imageAttachments)) {
      this.activityImageAttachments = imageAttachments;
    }

    return this.activityImageAttachments;
  };

  public attachDropDirection = (): boolean => {
    return true;
  };

  public addAttachmentToSend = (attachment: AttachmentActivity) => {
    this.emailAttachments.push(attachment);
  };

  public quillEditorReady = (editor: quill.Quill) => {
    this.quillEditor = editor;

    // Register for custom event handlers
    const toolbarModule = editor.getModule('toolbar');
    if (toolbarModule) {
      toolbarModule.addHandler('image', () => {
        this.toggleInlinePopup = !this.toggleInlinePopup;
      });
    }

    if (this.isNew()) {
      editor.focus();
    }
  };

  public removeAttachmentToSend = (attachment: AttachmentActivity) => {
    if (!this.isSaving()) {
      this.ticketService
        .deleteEmailAttachmentFile(this.activity.activityId, attachment.details.fileId)
        .pipe(
          switchMap(attachmentId => {
            if (attachmentId) {
              return this.attachmentService.deleteLocalAttachmentFile(attachmentId);
            } else {
              return of(attachmentId);
            }
          })
        )
        .subscribe(
          () => {
            this.emailAttachments = this.emailAttachments.filter(
              item => item.details.fileId !== attachment.details.fileId
            );
            this.emailAttachmentFiles = this.emailAttachmentFiles.filter(
              file => file.fileId !== attachment.details?.fileId
            );

            this.emailAttachmentsDictionary[attachment.details.fileName] -= 1;
            this.duplicateExists = false;
            for (let i in this.emailAttachmentsDictionary) {
              if (this.emailAttachmentsDictionary[i] > 1) {
                this.duplicateExists = true;
                break;
              }
            }

            this.globalEventBusService.broadcast(GlobalEvents.activityDeleted, this.activity);
          },
          error => (this.error = error)
        );
    }
  };

  /** Returns the list of attachments to be sent on a new email, or the list of sent attachments on an existing email */
  public getEmailAttachments = (): AttachmentActivity[] => {
    return this.emailAttachments;
  };

  /** Cancels sending the email and deletes it from the client */
  public cancel = async () => {
    if (this._isSaving) {
      return;
    }

    this._isSaving = true;

    try {
      if (this.activity.activityId) {
        this.ticketService
          .deleteActivity(this.activity.activityId, this.ticketContextService.ticket.ticketId)
          .pipe(take(1))
          .subscribe(() => {
            this.activityCtrl.onDelete.emit();
            this.toggleCollapseEmailBody = !this.toggleCollapseEmailBody;
            this.recipientsList = [];
          });
      } else {
        this.activityCtrl.onDelete.emit();
      }
    } finally {
      this._isSaving = false;
    }
  };

  /** Saves the current state of the activity on the server */
  public send = async () => {
    if (!this.validateRecipientList()) {
      return;
    }

    try {
      if (!this.validateInputs()) {
        return;
      }
      this._isSaving = true;
      const subject = this.getSubject();
      const attachment = this.getAttachmentActivity();
      this.rerender();

      this.email = {
        ticketId: parseInt(this.ticketContextService.ticket.ticketId),
        activityId: this.activity.activityId,
        recipients: this.createRecipientsArrayForSend(),
        body: this.body,
        subject: subject,
        attachmentActivityIds: attachment,
      };

      const [email, currentUser] = await zip(
        this.emailService.sendEmailFromTicket(this.email, this.ticketContextService.ticket.groupId),
        this.userInfoService.getCurrentUser()
      ).toPromise();
      this.activity.status = 'sending';
      this.handleSendSuccess(email, currentUser);
    } catch (err) {
      await this.saveDraftEmail();
      this.handleSendError(err);
    } finally {
      this._isSaving = false;
      this.toggleCollapseEmailBody = !this.toggleCollapseEmailBody;
    }
  };

  private validateInputs() {
    let valid = false;
    if (this.bodyIsWhitespaceOrEmpty() && this.recipientsIsEmpty() && this.emailAttachmentFiles.length == 0) {
      this.setError(this.$filter.transform('email_recipients_body_Empty'));
    } else if (this.bodyIsWhitespaceOrEmpty() && this.emailAttachmentFiles.length == 0) {
      this.setError(this.$filter.transform('email_body_Empty'));
    } else if (this.recipientsIsEmpty()) {
      this.setError(this.$filter.transform('email_recipients_Empty'));
    } else if (!this.hasInvalidRecipients() || this.validateRecipients()) {
      if (this._isSaving) {
        return;
      }
      valid = true;
    }
    return valid;
  }

  private getAttachmentActivity() {
    let attachmentActivityIds = this.getEmailAttachments().map(x => {
      return { fileId: x.details.fileId, fileName: x.details.fileName };
    });
    return attachmentActivityIds || [];
  }

  private getSubject() {
    return this.$filter.transform(
      'email_Send_Subject_Format',
      this.ticketContextService.ticket.shortGroupName,
      this.ticketContextService.ticket.ticketId,
      this.ticketContextService.ticket.title
    );
  }

  private handleSendSuccess(email, currentUser) {
    this.activity.status = 'sent';
    this.activity.activityType = ActivityTypeEnum[this.activity.activityTypeId];
    // this.activity.creationDate = new Date().toString();
    this.setError(undefined);
    this.updateEmailActivity();
    this.ticketService
      .saveActivity(this.activity as any, this.ticketContextService.ticket.ticketId)
      .pipe(take(1))
      .subscribe(
        email => {
          console.log(`saved sent email ${email.activityId}`);
          this.activity.activityId = email.activityId;
          this.updateEmailActivity();
          this.updateEmailActivityId();
          this.activityCtrl.creationUser = currentUser.displayName;
          this._isSaving = false;
          this.rerender();
          this.ticketPageService.refresh();
        },
        err => {
          this.$log.error(err);
          err.isHandled = true;
        },
        () => {
          this.isBodyDeltaDirty = false;
        }
      );
  }

  private validateRecipientList(): boolean {
    let invalidEmails: string[] = [];
    const emailPattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

    for (const recipient of this.recipientsList) {
      let emailAddress = (recipient as IUserEmailRecipient).user?.email || (recipient as IEmailRecipient)?.address;

      if (!emailAddress || !emailPattern.test(emailAddress)) {
        invalidEmails.push(emailAddress || '[Unknown Email]');
      }
    }

    if (invalidEmails.length > 0) {
      const errorMessage = this.$filter.transform('email_Recipients_FormatError', invalidEmails.join(', '));
      this.setError(errorMessage);
      return false;
    }

    return true;
  }

  private handleSendError(err) {
    this.activity.status = 'draft';
    console.log(`outbound email send error ${err}`);
    this.$log.debug('Failed to save email activity');
    let message: string = this.$filter.transform('email_Save_Error');
    if (err.status && err.status === 422) {
      // Start with the error provided but if it is just an activity id then use client message
      message = err.error_description;
      for (const attachmentActivity of this.emailAttachments) {
        if (attachmentActivity.activityId.toString() === err.error_description) {
          message = this.$filter.transform('email_Send_Attachment_Error', attachmentActivity.details.fileName);
        }
      }
    } else if (err.status === 413 || err.status === 403) {
      message = err.error_description;
    }
    this.updateEmailActivity();
    this.setError(message);
    err.isHandled = true;
    this.rerender();

    this.ticketPageService.refresh();
  }

  public recipientsIsEmpty = () => {
    return this.recipientsUserInfos.length === 0 && this.recipientsCCUserInfos.length === 0;
  };

  public showRecipients = () => {
    return !!this.recipientsUserInfos && this.recipientsUserInfos.length > 0;
  };

  public showCCRecipients = () => {
    return !!this.recipientsCCUserInfos && this.recipientsCCUserInfos.length > 0;
  };

  /** Sets the "To" recipients to the given value */
  public setRecipientsTo = (value: string) => {
    this.recipientsTo = value;
  };

  /** Sets the QuillJS Delta body content */
  public setBodyDelta = (value: any) => {
    this.bodyDelta = Object.assign({}, value.content); // angular.copy(value);
    this.isBodyDeltaDirty = true;
  };

  /** Determines whether this is a new email */
  public isNew = (): boolean => {
    // In case we have an error this means we still have a new activity.
    let isnewResult = this.error !== null && this.error !== undefined;
    if (!!this.activity) {
      isnewResult = isnewResult || !this.activity.activityId || this.activity.status === 'draft';
    }
    return isnewResult;
  };

  /** Determines whether this email is currently being saved */
  public isSaving = (): boolean => {
    return this._isSaving;
  };

  /** Determines whether this draft email is currently being saved */
  public isDraftSaving = (): boolean => {
    return this._isSaving;
  };

  /** Determines whether the inputs are disabled */
  public isDisabled = (): boolean => {
    return !this.isNew() || this.isSaving() || !this.canEdit;
  };

  /** Updates the activity state based on various attributes of the activity, model, and template */
  public updateActivityState = () => {
    let state: string;
    if (this.error) {
      state = 'error';
    } else if (this.isNew()) {
      state = 'active';
    } else {
      state = 'inactive';
    }
    this.activityCtrl.setActivityState(state);
  };

  /** Get the activity state */
  public isInactivityState = () => {
    return this.activityCtrl.getActivityState() === 'inactive';
  };

  /**
   * Called when an attachment on outbound email is selected
   * first condition is when the user selects a new file from local drive
   * second condition is when the user selects an attachment already uploaded to the activity
   */
  public onSelectAttachment = async (attachmentObj: EmailAttachment) => {
    if (attachmentObj.fileObj !== null) {
      const invalidFiles = [
        <File>{
          name: attachmentObj.fileObj.file.name,
          size: this.ticketPageService.getMaxAttachmentSize() * 1024 * 1024,
        },
      ];
      if (attachmentObj.fileObj.file && attachmentObj.fileObj.file.size < invalidFiles[0].size) {
        await this.addAttachment(attachmentObj.fileObj.file);
      } else {
        this.setInvalidFileError(invalidFiles, 'attachment_FileSizeExceeded_Error');
      }
    } else if (attachmentObj.attachment) {
      await this.saveEmailAttachment(attachmentObj.attachment);
    }
  };

  /**
   * Called when an inline attachment on RTE tool bar is selected
   * first condition is when the user selects a new file from local drive
   * second condition is when the user selects an attachment already uploaded to the activity
   */
  public onSelectInlineAttachment = async (attachmentObj: EmailAttachment) => {
    if (this.quillEditor) {
      // Get index of current selection in RTE and insert the image there
      const range = this.quillEditor.getSelection(true);
      const index = range ? range.index + range.length : this.quillEditor.getLength();

      if (attachmentObj.attachment) {
        // Check if we already have a cached attachment URL (base64) for this attachment
        let url: string;
        const cachedUrl = this.inlineImageAttachmentUrls.find(
          value => value.activityId === attachmentObj.attachment.activityId
        );
        if (cachedUrl) {
          url = cachedUrl.url;
        } else {
          // Fetch a new base64 attachment URL to insert
          url = await this.attachmentService.fetchMediaUrl(attachmentObj.attachment);
          this.inlineImageAttachmentUrls.push({ activityId: attachmentObj.attachment.activityId, url: url });
        }

        this.quillEditor.insertEmbed(index, 'image', url, 'user');
        this.quillEditor.setSelection(index + 1, 0, 'user');
      } else if (attachmentObj.fileObj) {
        // Add inline image from file
        const file = attachmentObj.fileObj.file;
        if (file) {
          if (file.type && file.type.toLowerCase().startsWith('image/')) {
            // Valid image file, convert to base64 and insert
            const url = await this.readFileAsBase64(file);
            this.quillEditor.insertEmbed(index, 'image', url, 'user');
            this.quillEditor.setSelection(index + 1, 0, 'user');
          } else {
            // Invalid image file, display error
            window.alert(this.$filter.transform('inlineImage_InvalidType_Error', file.name));
          }
        } else if (attachmentObj.fileObj.invalidFiles) {
          this.setInvalidFileError(attachmentObj.fileObj.invalidFiles, 'inlineImage_Browse_MaxSizeExceeded_Error');
        }
      }
    }

    // // Angular Hybrid Mode: Need to manually invoke a digest after 'async' returns, since the global Promise object
    // // is executed in the Angular Zone and *not* as part of the AngularJS digest cycle.
    // if (!this.$scope.$root.$$phase) {
    //     this.$scope.$digest();
    // }
  };

  public isEmailContentUpdating = () => {
    return this.isUploading || this.isSaving();
  };

  public setIsBodyFocused = async (isFocused: boolean) => {
    this.isBodyFocused = isFocused;
    // if (!this.$scope.$root.$$phase) {
    //     this.$scope.$digest();
    // }

    // if (!isFocused) {
    //     await this.saveDraftEmail();

    //     // Angular Hybrid Mode: Need to manually invoke a digest after 'async' returns, since the global Promise object
    //     // is executed in the Angular Zone and *not* as part of the AngularJS digest cycle.
    //     if (!this.$scope.$root.$$phase) {
    //         this.$scope.$digest();
    //     }
    // }
  };

  public localAttachmentMenuToggle = $event => {
    this.toggleAttachmentPopup = !this.toggleAttachmentPopup;
  };

  public emailAttachmentToggle = () => {
    return this.emailAttachmentToggle;
  };

  /** Returns a comma-seprated list of supported inline image extensions */
  public getImageExtensionList = () => {
    return this.imageExtensionList.join(',');
  };

  /** Returns the image compression settings for pasted images */
  public getCompressionSettings = (): any => {
    return OutboundEmailActivityComponent.imageCompressionSettings;
  };

  public addRecipient = (eventData: any) => {
    const recipient: IUserInfoModel = eventData.recipient;
    const recipientType: emailRecipientType = eventData.recipientType;
    const resolutionCallback = eventData.resolutionCallback;

    (<IUserEmailRecipient[]>this.recipientsList).push({
      user: recipient,
      userId: recipient.userId,
      address: recipient.email,
      recipientType,
      isBeingResolved: resolutionCallback ? true : false,
      isInvalidAddress: !this.testRecipient(recipient.email),
    } as IUserEmailRecipient);
    const indexOfRecipient = this.recipientsList.length - 1;
    const recipientUserId = recipient.userId;
    // If recipientslistComponent passed in just an email
    if (!recipientUserId && !(<IUserEmailRecipient[]>this.recipientsList)[indexOfRecipient].isInvalidAddress) {
      // Resolve the email to a user & invoke the resolutionCallback so that it can add the user's userinfoId to its excludeList
      this.userInfoService.getUserInfo(null, null, recipient.email, null).subscribe(
        (resolvedUser: IUserInfoModel) => {
          const resolvedUserId = resolvedUser.userId;

          if (resolutionCallback) {
            resolutionCallback(resolvedUserId);
          }

          if (
            this.recipientsList[indexOfRecipient] &&
            (<IUserEmailRecipient[]>this.recipientsList)[indexOfRecipient].user.email === recipient.email
          ) {
            (<IUserEmailRecipient[]>this.recipientsList)[indexOfRecipient] = {
              user: resolvedUser,
              userId: resolvedUser.userId,
              address: resolvedUser.email,
              recipientType,
              isBeingResolved: false,
              isInvalidAddress: false,
            } as IUserEmailRecipient;
            const recipientListToSplice =
              recipientType === 'to' ? this.recipientsUserInfos : this.recipientsCCUserInfos;
            recipientListToSplice[pushedRecipientIndex] = resolvedUser;
          }
        },
        err => {
          this.$log.error(err);
        }
      );
    }
    const recipientListToSplice = recipientType === 'to' ? this.recipientsUserInfos : this.recipientsCCUserInfos;
    recipientListToSplice.push(recipient);
    const pushedRecipientIndex = recipientListToSplice.length - 1;
  };

  public removeEmailRecipient(recipient) {
    const recipientListToSplice =
      recipient['recipientType'] === 'to' ? this.recipientsUserInfos : this.recipientsCCUserInfos;
    const indexOfRecipientInArray = recipientListToSplice.indexOf(recipient['recipient']);
    const indexOfRecipientInService = (<IUserEmailRecipient[]>this.recipientsList).findIndex(
      recip => recip.user === recipient.recipient
    );
    if (indexOfRecipientInArray > -1) {
      recipientListToSplice.splice(indexOfRecipientInArray, 1);
    }
    if (indexOfRecipientInService > -1) {
      this.recipientsList.splice(indexOfRecipientInService, 1);
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  public isLoading = (recipientType: string) => {
    if (Object.keys(this.recipientsList).includes('recipient')) {
      const isAnyRecipientBeingResolved = (<IUserEmailRecipient[]>this.recipientsList['recipient']).find(
        recipient => recipient.recipientType === recipientType && recipient.isBeingResolved === true
      );
      return isAnyRecipientBeingResolved || false;
    }
    const isAnyRecipientBeingResolved = (<IUserEmailRecipient[]>this.recipientsList).find(
      recipient => recipient.recipientType === recipientType && recipient.isBeingResolved === true
    );
    return isAnyRecipientBeingResolved || false;
  };

  private tryParseJSON = (jsonString: string): any => {
    try {
      const o = JSON.parse(jsonString);

      // Handle non-exception-throwing cases:
      // Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
      // but... JSON.parse(null) returns null, and typeof null === "object",
      // so we must check for that, too. Thankfully, null is falsey, so this suffices:
      if (o && typeof o === 'object') {
        return o;
      }
    } catch (e) {
      this.$log.debug('Parameter is not a json string.');
    }

    return null;
  };

  /**
   *  forceSave is set to true when the email draft should be saved even the body is not modified.
   */
  private saveDraftEmail = async (forceSave?: boolean): Promise<void> => {
    // check if body is modified
    this.activity.status = 'draft';
    this.activity.activityType = ActivityTypeEnum[this.activity.activityTypeId];
    return new Promise((resolve, reject) => {
      if (!this.isBodyDeltaDirty && !forceSave) {
        resolve();
      }

      // check for sent email
      if (!this.isEmailDraft()) {
        resolve();
      }
      this.updateEmailActivity();
      this.ticketService.saveActivity(this.activity as any, this.ticketContextService.ticket.ticketId, false).subscribe(
        res => {
          console.log(`saved draft email ${res.activityId}`);
          this.activity.activityId = res.activityId;
          resolve();
        },
        err => {
          this.$log.error(err);
          err.isHandled = true;
          this.setError(this.$filter.transform('email_Draft_Save_fail'));
          reject();
        },
        () => {
          this.isBodyDeltaDirty = false;
        }
      );
    });
  };

  private onRefreshOrNavigateAway = async () => {
    if (this.isEmailDraft()) {
      await this.saveDraftEmail();
    }
  };

  private isEmailDraft = (): boolean => {
    return this.activity.details?.status === 'draft' || !this.activity.activityId;
  };

  private addAttachment = async (file: File) => {
    this.isUploading = true;
    const count = this.emailAttachmentsDictionary[file.name];
    const modifiedFileName = count > 0 ? this.appendCountToFileName(file.name, count) : file.name;

    this.attachmentService
      .uploadAttachment(file, 'attachment')
      .pipe(take(1))
      .subscribe(resultData => {
        const result = {
          details: {
            fileId: resultData.attachmentId,
            fileName: resultData.fileName,
            fileSize: resultData.fileSize,
            displayName: modifiedFileName,
          },
        } as AttachmentActivity;
        setTimeout(() => {
          this.progress = 100;
        }, 500);

        if (this.isNew()) {
          this.saveEmailAttachment(result);
        }
      });
  };

  private appendCountToFileName = (fileName: string, count: number): string => {
    const fileExtension = fileName.split('.').pop(); // Extract file extension
    const baseFileName = fileName.substring(0, fileName.lastIndexOf('.')); // Remove existing extension
    const modifiedFileName = `${baseFileName}(${count}).${fileExtension}`;
    return modifiedFileName;
  };

  private getBaseFileName = (fileName: string): string => {
    const lastDotIndex = fileName.lastIndexOf('.');
    return lastDotIndex !== -1 ? fileName.substring(0, lastDotIndex) : fileName;
  };

  private saveEmailAttachment = async (attachmentModel: AttachmentActivity) => {
    if (!this.activity.activityId) {
      await this.saveDraftEmail(true);
    }
    this.error = undefined;
    const emailAttachmentFile = {
      fileId: attachmentModel.details.fileId,
      fileName: attachmentModel.details.fileName,
      fileSize: attachmentModel.details.fileSize,
      displayName: attachmentModel.details.displayName,
    } as EmailAttachmentFile;

    this.ticketService
      .attachFileToEmail(this.activity.activityId, emailAttachmentFile)
      .pipe(take(1))
      .subscribe(
        () => {
          const attachmentAct = {
            activityId: this.activity.activityId,
            activityTypeId: this.activity.activityTypeId,
            details: {
              fileName: emailAttachmentFile.fileName,
              fileSize: emailAttachmentFile.fileSize,
              fileId: emailAttachmentFile.fileId,
              displayName: emailAttachmentFile.displayName,
            },
          } as AttachmentActivity;

          //Todo use different way to store email attachments
          this.emailAttachments.push(attachmentAct);
          this.emailAttachmentFiles.push(emailAttachmentFile);

          if (attachmentAct.details.fileName in this.emailAttachmentsDictionary) {
            this.emailAttachmentsDictionary[attachmentAct.details.fileName] =
              this.emailAttachmentsDictionary[attachmentAct.details.fileName] + 1;
          } else {
            this.emailAttachmentsDictionary[attachmentAct.details.fileName] = 1;
          }

          for (let i in this.emailAttachmentsDictionary) {
            if (this.emailAttachmentsDictionary[i] > 1) {
              this.duplicateExists = true;
            }
          }
        },
        error => (this.error = error),
        () => {
          this.isUploading = false;
        }
      );
  };

  private readFileAsBase64 = (file: File): Promise<string> => {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        /* Type FileReaderProgressEvent is removed in TypeScript v3.0+ */
        resolve(e.target.result);
      };

      reader.readAsDataURL(file);
    });
  };

  private replaceInlineImageDeltas = (delta: any) => {
    if (!delta) {
      return;
    }
    // Replace all inline image attachment URLs with custom imageId Delta
    for (const image of this.inlineImageAttachmentUrls) {
      // Search for this URL in the Delta
      for (const op of delta.ops) {
        if (op.insert && op.insert.image && op.insert.image === image.url) {
          // Set a custom imageId Delta attribute and clear the image URL
          (<any>op).imageId = image.activityId;
          op.insert.image = '';
        }
      }
    }
  };

  private setInvalidFileError = (invalidFiles: File[], resourceString: string) => {
    if (invalidFiles.length > 0) {
      // Invalid file selected (i.e. attachment size exceeded), show an error
      const maxFileSizeBytes = this.ticketPageService.getMaxAttachmentSize() * 1024 * 1024;
      const message = this.$filter.transform(
        resourceString,
        invalidFiles[0].name,
        this.fileSizeFormatter.transform(maxFileSizeBytes)
      );
      window.alert(message);
    }
  };

  private bodyIsWhitespaceOrEmpty = (): boolean => {
    const text = this.quillEditor.getText();
    if (text.replace(/<(.|\n)*?>/g, '').trim().length === 0 && !text.includes('<img')) {
      return true;
    }
    return false;
  };

  private parseRecipients = (): IEmailRecipient[] => {
    let emailRecepientsList = this.constructRecipientsArray('to', this.recipientsTo);
    emailRecepientsList = emailRecepientsList.concat(this.constructRecipientsArray('cc', this.recipientsCC));
    return emailRecepientsList;
  };

  private constructRecipientsArray = (
    recipientType: emailRecipientType,
    recepientString: string
  ): IEmailRecipient[] => {
    const emailRecepientsList: IEmailRecipient[] = [];
    if (typeof recepientString == typeof undefined) {
      const emailAddressList: string[] = this.formatEmailAddress(recepientString);
      emailAddressList.forEach(recipient => {
        const emailRecepient: IEmailRecipient = {
          address: recipient,
          name: null,
          recipientType,
        };
        emailRecepientsList.push(emailRecepient);
      });
    }
    return emailRecepientsList;
  };

  private convertToRecipientString = (recipientType: emailRecipientType): string => {
    const recepientsStringList: string[] = [];
    for (const recipient of <IEmailRecipient[]>this.recipientsList) {
      if (recipient.recipientType.toLocaleLowerCase() === recipientType.toLocaleLowerCase()) {
        recepientsStringList.push(recipient.address);
      }
    }

    let recipientsString = recepientsStringList.join(' ');

    // Add trailing space
    if (this.recipientsList.length > 0) {
      recipientsString = recipientsString + ' ';
    }

    return recipientsString;
  };

  private formatEmailAddress = (recipientsText: string): string[] => {
    // Split the recipients text on commas and spaces (or multiples)
    const recipients: string[] = recipientsText.split(/[ ,]+/);

    // Remove blank recipients from the end
    if (recipients && recipients.length > 0 && !recipients[recipients.length - 1]) {
      recipients.splice(recipients.length - 1);
    }

    // Remove blank recipients from the beginning
    if (recipients && recipients.length > 0 && !recipients[0]) {
      recipients.splice(0, 1);
    }
    return recipients;
  };

  private validateRecipients = (): boolean => {
    let error = '';
    const pattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    for (const element of <any>this.recipientsList) {
      const xpattern = new RegExp(pattern.source, 'g');
      const address = element.user.email;
      if (!xpattern.test(address)) {
        error += ', ' + address;
      }
    }

    if (!!error) {
      // To remove prefix ','
      error = error.substr(2);

      error = this.$filter.transform('email_Recipients_FormatError', error);
      this.setError(error);
      return false;
    }

    return true;
  };

  private updateEmailActivity() {
    this.activity.activityTypeId = ActivityTypeEnum.outboundEmail;
    this.activity.body = this.prepareEmailBody();

    this.updateActivityState();
  }

  private updateEmailActivityId() {
    this.ticketService
      .getActivity(parseInt(this.ticketContextService.ticket.ticketId), this.activity.activityId)
      .pipe(take(1))
      .subscribe(activity => {
        this.activity.creationDate = activity.creationDate;
      });
  }

  private setError(err: string) {
    if (this.error !== err) {
      this.error = err;
      this.updateActivityState();
    }
  }

  private findAttachmentsInActivities = (activities: Activity[]): AttachmentActivity[] => {
    // Recursively build a dictionary of attachments on fileId to ensure uniqueness
    const attachmentsDictionary: { [fileId: string]: AttachmentActivity } = {};
    if (activities) {
      for (const activity of activities) {
        if (activity.activityTypeId === ActivityTypeEnum.attachment) {
          const attachmentActivity = <AttachmentActivity>activity;
          attachmentsDictionary[attachmentActivity.details.fileId] = attachmentActivity;
        }
        if (activity.activityTypeId === ActivityTypeEnum.remoteControl) {
          const newAttachments = this.findAttachmentsInActivities(activity.childActivities);
          for (const attachmentActivity of newAttachments) {
            attachmentsDictionary[attachmentActivity.details.fileId] = attachmentActivity;
          }
        }
        if (activity.activityTypeId === ActivityTypeEnum.inboundEmail) {
          const newAttachments = this.findAttachmentsInActivities(activity.childActivities);
          for (const attachmentActivity of newAttachments) {
            attachmentsDictionary[attachmentActivity.details.fileId] = attachmentActivity;
          }
        }
        if (activity.activityTypeId === ActivityTypeEnum.outboundEmail) {
          const newAttachments = this.findAttachmentsInActivities(activity.childActivities);
          for (const attachmentActivity of newAttachments) {
            attachmentsDictionary[attachmentActivity.details.fileId] = attachmentActivity;
          }
        }
        if (activity.activityTypeId === ActivityTypeEnum.deviceVideo) {
          const newAttachments = this.findAttachmentsInActivities(activity.childActivities);
          for (const attachmentActivity of newAttachments) {
            attachmentsDictionary[attachmentActivity.details.fileId] = attachmentActivity;
          }
        }
      }
    }
    // Create an array from the dictionary and return it
    const attachments: AttachmentActivity[] = [];
    for (const fileId in attachmentsDictionary) {
      if (attachmentsDictionary.hasOwnProperty(fileId)) {
        attachments.push(attachmentsDictionary[fileId]);
      }
    }
    return attachments;
  };

  /** Pre-processes the delta JSON on the activity's body text to detect inline image attachments */
  private preProcessDelta = async (): Promise<any> => {
    try {
      this.inlineImageAttachmentUrls = [];

      const delta = this.email.body;

      if (delta !== undefined && delta !== null) {
        for (const op of delta.ops) {
          const imageId = (<any>op).imageId;
          if (imageId && op.insert.image) {
            // Convert image URL to base64
            op.insert.image = await this.attachmentService.fetchImageBase64(op.insert.image);
            this.inlineImageAttachmentUrls.push({ activityId: imageId, url: op.insert.image });
          }
        }
      }

      return delta;
    } catch (err) {
      this.$log.debug('Failed to parse email activity body');
      this.$log.error(err);
      return null;
    }
  };

  /** Determines if the specified activityId is an inline image attachment activity */
  private isInlineImageAttachment = (activityId: number): boolean => {
    return !!this.inlineImageAttachmentUrls.find(e => e.activityId === activityId);
  };

  private createRecipientsArray = () => {
    const constructedRecipientsList: IEmailRecipient[] = [];
    for (const recipient of this.recipientsUserInfos) {
      if (recipient.email) {
        const emailRecipient: IEmailRecipient = {
          address: recipient.email,
          name: recipient.displayName,
          recipientType: 'to',
          userId: recipient.userId,
        };
        constructedRecipientsList.push(emailRecipient);
      }
    }
    for (const recipient of this.recipientsCCUserInfos) {
      if (recipient.email) {
        const emailRecipient: IEmailRecipient = {
          address: recipient.email,
          name: recipient.displayName,
          recipientType: 'cc',
          userId: recipient.userId,
        };
        constructedRecipientsList.push(emailRecipient);
      }
    }
    return constructedRecipientsList;
  };

  private createRecipientsArrayForSend = () => {
    const constructedRecipientsList: IEmailRecipient[] = [];
    for (const recipient of this.recipientsUserInfos) {
      if (recipient.email) {
        const emailRecipient = {
          address: recipient.email,
          name: recipient.displayName,
          recipientType: 'to',
          userInfoPublicId: recipient.userId,
          userType: recipient.userType,
        };

        constructedRecipientsList.push(emailRecipient);
      }
    }
    for (const recipient of this.recipientsCCUserInfos) {
      if (recipient.email) {
        const emailRecipient = {
          address: recipient.email,
          name: recipient.displayName,
          recipientType: 'cc',
          userInfoPublicId: recipient.userId,
          userType: recipient.userType,
        };
        constructedRecipientsList.push(emailRecipient);
      }
    }
    return constructedRecipientsList;
  };

  private updateReporter(updatedReporter: IReporterModel) {
    const userInfoIndex = this.recipientsUserInfos.findIndex(
      r => r.userId === updatedReporter.reporterId.toLowerCase()
    );
    const fullName = updatedReporter.firstName + ' ' + updatedReporter.lastName;
    if (userInfoIndex !== -1) {
      var userInfo = this.recipientsUserInfos[userInfoIndex];
      userInfo.email = updatedReporter.email;
      userInfo.firstName = updatedReporter.firstName;
      userInfo.lastName = updatedReporter.lastName;
      userInfo.displayName = fullName;
    }

    const recipientIndex = this.email.recipients.findIndex(r => r.userId === updatedReporter.reporterId.toLowerCase());
    if (recipientIndex !== -1) {
      var recipient = this.email.recipients[recipientIndex];
      recipient.name = fullName;
      recipient.address = updatedReporter.email;
    }

    if (this.isNew() && userInfoIndex === -1) {
      var rec = {
        displayName: fullName,
        email: updatedReporter.email,
        firstName: updatedReporter.firstName,
        lastName: updatedReporter.lastName,
        isEditable: false,
        phoneNumber: '',
        userId: updatedReporter.reporterId,
        userType: 'Manual',
      } as IUserInfoModel;

      this.addRecipient({ recipient: rec, recipientType: 'to' });
    }
  }

  private parseUpdatedRecipientsList = () => {
    if (this.isNew()) {
      this.recipientsUserInfos = [];
      this.recipientsCCUserInfos = [];

      for (const recipient of <IUserEmailRecipient[]>this.recipientsList) {
        const correspondingArray =
          recipient.recipientType === 'to' ? this.recipientsUserInfos : this.recipientsCCUserInfos;
        correspondingArray.push(recipient.user);
      }
    }
  };

  /** Whether the given string is in valid email format */
  private testRecipient = (recipient: string) => {
    const xpattern = new RegExp(this.pattern, 'gm');
    return xpattern.test(recipient);
  };

  private hasInvalidRecipients = () => {
    const invalidRecipients = (<IUserEmailRecipient[]>this.recipientsList).filter(
      recipient => recipient.isInvalidAddress
    );
    if (invalidRecipients.length > 0) {
      // const modalInstance = this.$uibModal.open({
      //     template: require('raw-loader!./invalidEmailModal/InvalidEmailModal.tpl.html'),
      //     controller: InvalidEmailModalController,
      //     controllerAs: '$ctrl',
      //     backdrop: 'static',
      //     size: 'sm',
      //     resolve: {
      //         invalidRecipientsList: () => invalidRecipients
      //     }
      // });
    }
    return invalidRecipients.length > 0;
  };

  private prepareEmailBody = (): string => {
    this.replaceInlineImageDeltas(this.bodyDelta);

    const body: EmailContainer = {
      recipients: this.createRecipientsArray(),
      body: this.bodyDelta ? this.bodyDelta : { ops: [{ insert: '' }] },
      attachmentActivityIds: this.getAttachmentActivity(),
      subject: this.getSubject(),
      activityId: this.activity.activityId,
      ticketId: parseInt(this.ticketContextService.ticket.ticketId),
    };
    return JSON.stringify(body);
  };

  public setupQuill = (editor: Quill) => {
    this.quillEditor = editor;
  };

  public rerenderProps: Array<number> = [1];

  public rerender(): void {
    this.rerenderProps[0]++;
  }

  public prepareQuillModules = () => {
    const n = Quill.import('ui/icons');
    n.color = '<span class="sa-rte-icon-text-color" /> <span class="sa-rte-icon-color-bar" />';

    n.background = '<span class="sa-rte-icon-background-color" /> <span class="sa-rte-icon-color-bar" />';
    n.bold = '<span class="sa-rte-icon-bold" aria-hidden="true" />';
    n.italic = '<span class="sa-rte-icon-italic" aria-hidden="true" />';
    n.underline = '<span class="sa-rte-icon-underline" aria-hidden="true" />';
    n.strike = '<span class="sa-rte-icon-strikethrough" aria-hidden="true" />';
    n.indent['+1'] = '<span class="sa-rte-icon-add-indent" aria-hidden="true" />';
    n.indent[-1] = '<span class="sa-rte-icon-remove-indent" aria-hidden="true" />';
    n.list.bullet = '<span class="sa-rte-icon-bullet-list" aria-hidden="true" />';
    n.list.ordered = '<span class="sa-rte-icon-numbered-list" aria-hidden="true" />';
    n.clean = '<span class="sa-rte-icon-remove-style" />';
    n.image = '<span class="sa-rte-icon-icon-filetype-img" />';

    const SizeStyle = Quill.import('attributors/style/size');
    SizeStyle.whitelist = ['0.75em', '1.5em', '2.5em'];
    Quill.register(SizeStyle, true);

    return {
      toolbar: {
        container: [
          [
            { size: ['saFontSize', 'saHSeparator', '0.75em', false, '1.5em', '2.5em'] },
            'saVSeparator',
            { color: [] },
            'saVSeparator',
            { background: [] },
          ],

          ['bold', 'saVSeparator', 'italic', 'saVSeparator', 'underline', 'saVSeparator', 'strike'],

          [{ indent: '-1' }, 'saVSeparator', { indent: '+1' }],

          [{ list: 'bullet' }, 'saVSeparator', { list: 'ordered' }],
          ['clean'],
          ['image'],
        ],
        // eslint-disable-next-line quote-props
        handlers: {
          saVSeparator: () => {},
          image: () => (this.toggleInlinePopup = !this.toggleInlinePopup),
        },
      },
    };
  };
}
